const GRID =
  "https://static.prod-images.emergentagent.com/jobs/c145874f-77be-43ac-ab7b-47d69079da54/images/90d6d25c049c450c0a87b53d685c70e88e33aafb074cf997e7ed5524c0a6c3fd.png";

const insights = [
  {
    tag: "Compounding",
    title: "Why money in a savings account is making the bank rich, not you",
    read: "5 min read",
    excerpt:
      "Your bank pays you 0.5% and lends your money out at 7%. Here's exactly what that costs you over 10 years — and where it should be going instead.",
  },
  {
    tag: "Stock Picks",
    title: "How I pick stocks built for long-term compounding",
    read: "8 min read",
    excerpt:
      "Long-term conviction, smart-money positioning, and three filters I run every name through before a single dollar goes in.",
  },
  {
    tag: "Mindset",
    title: "Start at 17 or start at 47 — the math the crowd ignores",
    read: "6 min read",
    excerpt:
      "Time is the most underpriced asset in your portfolio. The earlier you start, the less you'll ever have to contribute. Here's the proof.",
  },
  {
    tag: "Portfolio",
    title: "Building your first real portfolio — without gambling",
    read: "9 min read",
    excerpt:
      "Index core, conviction satellites, and the allocation framework I use with everyone I mentor when they're just getting started.",
  },
];

export const Insights = () => {
  return (
    <section
      id="insights"
      data-testid="insights-section"
      className="relative py-32 lg:py-40 border-t border-white/5 overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-[480px] -z-10 opacity-40">
        <img src={GRID} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#050505]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-20">
          <div>
            <p className="text-xs uppercase tracking-[0.35em] text-emerald-400 mb-6">
              — Smart Money Insights
            </p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight max-w-3xl">
              Read what the desks <em className="italic text-emerald-400">don't tell you.</em>
            </h2>
          </div>
          <a
            href="#book"
            data-testid="insights-all"
            className="text-amber-500 hover:text-amber-300 text-sm uppercase tracking-[0.3em]"
          >
            Get the full archive →
          </a>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {insights.map((post, i) => (
            <article
              key={post.title}
              data-testid={`insight-card-${i}`}
              className="group rounded-3xl border border-white/10 bg-[#0A0A0A] p-8 lg:p-10 hover:border-emerald-500/40 hover:-translate-y-1 transition-all duration-500 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-8">
                <span className="text-[10px] uppercase tracking-[0.3em] px-3 py-1.5 rounded-full bg-emerald-500/10 text-emerald-400 border border-emerald-500/20">
                  {post.tag}
                </span>
                <span className="text-xs text-zinc-500">{post.read}</span>
              </div>
              <h3 className="font-serif-display text-2xl sm:text-3xl text-white leading-snug group-hover:text-emerald-300 transition-colors">
                {post.title}
              </h3>
              <p className="mt-6 text-zinc-400 leading-relaxed">
                {post.excerpt}
              </p>
              <div className="mt-8 flex items-center gap-3 text-sm text-zinc-500 group-hover:text-amber-400 transition-colors">
                <span>Read article</span>
                <span className="h-px w-10 bg-current transition-all group-hover:w-16" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
